// VERSION : 0.0.1
// AUTHOR : VIGNESH
// LAST EDIT : VIGNESH
// MODIFIED DATE: 07-12-2025
// LAST CHANGED : ADDED COMMENT LINES

import DataVerificationReportActionTypes from './data-verification-report.type';

/****************  GET DATA VERIFICATION REPORT LIST START *********************** */
export const getDataVerificationReportDetailsStart = (getData: any) => ({
	type: DataVerificationReportActionTypes.GET_DATA_VERIFICATION_REPORT_LIST_START,
	payload: getData,
});

export const getDataVerificationReportDetailsSuccess = (successData: any) => ({
	type: DataVerificationReportActionTypes.GET_DATA_VERIFICATION_REPORT_LIST_SUCCESS,
	payload: successData,
});

export const getDataVerificationReportDetailsFailure = (failureData: any) => ({
	type: DataVerificationReportActionTypes.GET_DATA_VERIFICATION_REPORT_LIST_FAILURE,
	payload: failureData,
});

export const getDataVerificationReportDetailsResponseResetStart = () => ({
	type: DataVerificationReportActionTypes.GET_DATA_VERIFICATION_REPORT_LIST_RESPONSE_RESET,
});

export const getDataVerificationReportDetailsResponseChanged = () => ({
	type: DataVerificationReportActionTypes.GET_DATA_VERIFICATION_REPORT_LIST_RESPONSE_CHANGED,
});
/****************  GET DATA VERIFICATION REPORT LIST END *********************** */
